// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__W5CUi","main":"layout_main__lt5Mc"};